import dynamic from "next/dynamic"
import Head from "next/head";
import { handleRateLimit } from "utils/handleRateLimit";
import { getClientIp } from "utils/requestHelpers";

const TrackingPage = dynamic(() => import("../../js/Components/Tracking/Tracking"));

const Index = ({ data }) => {
    return (
        <>
            <Head>
                <title>{`Track your order ${process.env.brand.brand_name}`}</title>
                <meta
                    name="description"
                    content={`${process.env.brand.brand_name} offer furniture hire and chair rental throughout the UK. Our product range includes chairs to hire, conference furniture tables to hire, exhibition furniture hire, and office furntiture hire`}
                />
                <meta name="keywords" content="Furniture Hire London" />
            </Head>
            <TrackingPage trackingData={data} />
        </>
    )
}


export async function getServerSideProps({ req, res }) {
    const { headers } = getClientIp(req);

    const apiReq = await fetch(`${process.env.BASE_API_URL}get-tracking-content`, {
        headers,
    });

    let data = null;

    try {
        data = await apiReq.json();
    } catch (error) {
        console.error('Invalid API response:', error);
    }

    const rateLimitRedirect = handleRateLimit(
        res,
        apiReq,
        data
    );

    if (rateLimitRedirect) {
        return rateLimitRedirect;
    }

    if (data.exception) {
        return { notFound: true }
    }

    return {
        props: {
            data
        }
    }
}


export default Index